import { patientEndpoints } from '../../endpoints';
import {
  GET_PATIENT_ORDERS, GET_PATIENT_PROFILE, SHOW_ORDERS, RESET_PATIENT_ORDERS,
  PATIENT_PROFILE_RESET
} from '../types/patient';
import { getData } from '../../utility/mmur_service_com';

export const getPatientProfile = (patientIdEncrypted: string, refreshApplicationStatus: boolean) => (dispatch) => {
  dispatch(
    { type: SHOW_ORDERS, payload: false }
  );
  const url = patientEndpoints.getPatient(patientIdEncrypted, refreshApplicationStatus);
  getData(url, dispatch, GET_PATIENT_PROFILE);
};

export const getPatientOrders = (patientIdEncrypted: string, options) => (dispatch) => {
  dispatch({
    type: RESET_PATIENT_ORDERS,
  });
  dispatch({
    type: SHOW_ORDERS, payload: true
  });
  const url = patientEndpoints.getOrders(patientIdEncrypted, options);
  getData(url, dispatch, GET_PATIENT_ORDERS);
};

export const setShowOrders = (value) => (dispatch) => {
  dispatch({ type: SHOW_ORDERS, payload: value });
};

export const resetPatientProfile = () => ({
  type: PATIENT_PROFILE_RESET
});
